import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchLevel2ApproverList = async (params = {}) => {
  const { companyId, expenseCategoryId, plannedVesselRevisionId } = params;
  if (companyId == null || companyId === '' || expenseCategoryId == null || expenseCategoryId === '') {
    return Promise.reject(new Error('companyId and expenseCategoryId are required'));
  }
  const searchParams = new URLSearchParams({
    companyId: String(companyId),
    expenseCategoryId: String(expenseCategoryId),
    vesselId: String(plannedVesselRevisionId ?? '')
  });
  const url = `${apiurl?.getLevel2ApproverList}?${searchParams.toString()}`;
  const response = await axios.get(url);
  const body = response?.data;
  const list = Array.isArray(body)
    ? body
    : (body?.arqApprovers ?? body?.data?.arqApprovers ?? body?.data ?? body?.result);
  return { ...response, data: Array.isArray(list) ? list : [] };
};

const getLevel2ApproverList = (params = {}, options = {}) => {
  const { companyId, expenseCategoryId, plannedVesselRevisionId } = params;
  const enabled = Boolean(companyId != null && companyId !== '' && expenseCategoryId != null && expenseCategoryId !== '');

  return useQuery(
    ['getLevel2ApproverList', companyId, expenseCategoryId, plannedVesselRevisionId],
    () => fetchLevel2ApproverList({ companyId, expenseCategoryId, plannedVesselRevisionId }),
    {
      enabled: enabled && (options?.enabled !== false),
      refetchOnWindowFocus: false,
      ...options
    }
  );
};

export default getLevel2ApproverList;
